import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import PinIcon from '../../icons/pin.svg';
import planetSearchIcon from '../../styles/theme/disney/Planet_Search.svg';
import rocketIcon from '../../styles/theme/childrenDay/rocket_icon.svg';
import flowerIcon from '../../styles/theme/mothersDay/flower_icon.svg';
import {
  CITY_THEME_CHILDRENS_DAY,
  CITY_THEME_DISNEY,
  CITY_THEME_MOTHERS_DAY,
  isThemeActive,
  isVisualThemeActive,
} from '../../utils/cityTheme';

export default function PinMarkerIcon({ className }) {
  const userCity = useSelector(state => state.city.userCity);

  if (isVisualThemeActive(userCity, CITY_THEME_DISNEY)) {
    return <img src={planetSearchIcon} className={className} alt="" role="presentation" />;
  }

  if (isThemeActive(userCity, CITY_THEME_CHILDRENS_DAY)) {
    return <img src={rocketIcon} className={className} alt="" role="presentation" />;
  }

  if (isThemeActive(userCity, CITY_THEME_MOTHERS_DAY)) {
    return <img src={flowerIcon} className={className} alt="" role="presentation" />;
  }

  return <PinIcon className={className} />;
}

PinMarkerIcon.propTypes = {
  className: PropTypes.string,
};

PinMarkerIcon.defaultProps = {
  className: '',
};
